import api from '../lib/api';
import { User, PaginatedResponse } from '../types';

export interface MeResponse {
  id: string;
  name: string;
  email: string;
  permissions: string[];
  managerId: string | null;
  manager: { id: string; name: string } | null;
  jobTitleId: string | null;
  jobTitle: { id: string; name: string } | null;
  createdAt: string;
}

export interface CreateUserBody {
  name: string;
  email: string;
  permissions?: string[];
  managerId: string;
  jobTitleId: string;
}

export interface UpdateUserBody {
  name?: string;
  permissions?: string[];
  managerId?: string | null;
  jobTitleId?: string | null;
}

export const usersApi = {
  me: () => api.get<MeResponse>('/api/v1/users/me'),
  list: (
    params?: {
      page?: number;
      limit?: number;
      name?: string;
      jobTitleId?: string;
      includeDeleted?: boolean;
      excludeProjectId?: string;
      sortBy?: 'name' | 'manager' | 'createdAt';
      sortDir?: 'asc' | 'desc';
    },
    signal?: AbortSignal,
  ) => api.get<PaginatedResponse<User>>('/api/v1/users', { params, signal }),
  create: (body: CreateUserBody) =>
    api.post<User>('/api/v1/users', body),
  getById: (id: string) =>
    api.get<User>(`/api/v1/users/${id}`),
  update: (id: string, body: UpdateUserBody) =>
    api.patch<User>(`/api/v1/users/${id}`, body),
  delete: (id: string) =>
    api.delete(`/api/v1/users/${id}`),
};
